export default "__VITE_ASSET__BySNiwdw__"